/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class DefaultInvoiceTranslationsResource {
  private readonly uri: string = ApiConfig.obtain().getVersionedUri('invoicetranslations/defaults');
  private readonly send: AdnHttpSender;

  defaultInvoiceTranslations: any;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get(): Promise<any> {
    if (this.defaultInvoiceTranslations) {
      return Promise.resolve(this.defaultInvoiceTranslations);
    }
    return this.send({method: 'GET', url: this.uri, params: {context: null}}).then((data: any) => {
      this.defaultInvoiceTranslations = data;
      return this.defaultInvoiceTranslations;
    });
  }
}
